import _ from 'lodash';

import { HTTP_METHOD } from 'constants/http';
import { getIsNativePlatform } from 'utils/platform';

// Matches the loan-editor management route (/applications/:id/management/... and
// /loans/:id/management/...). A 403 raised while the editor is open is an expected,
// gracefully-degradable secondary-panel denial for subtree-scoped TPO brokers, not a
// stale-session signal — so the global 403 reload must not fire there (DEV-4226).
const LOAN_EDITOR_ROUTE_PATTERN = /\/(applications|loans)\/[^/]+\/management(\/|$)/;

export const isLoanEditorRoute = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return LOAN_EDITOR_ROUTE_PATTERN.test(window.location.pathname);
};

// Only safe/idempotent reads are eligible for the route-level broker suppression — a 403 on a GET
// is a degradable "can't see this panel" denial, but the SAME suppression applied to a
// POST/PUT/PATCH/DELETE would silence a FAILED SAVE: the broker would see no error and believe
// their write persisted when it didn't (silent data loss). Method is read defensively — an axios
// error with no readable method is treated as NOT a read, i.e. surfaced, failing safe toward
// visibility rather than toward silence (DEV-4226).
const READ_HTTP_METHODS = [HTTP_METHOD.GET, HTTP_METHOD.HEAD];

export const isReadRequestError = error => {
  const method = error?.config?.method || error?.response?.config?.method;

  if (!_.isString(method)) {
    return false;
  }

  return READ_HTTP_METHODS.includes(method.toLowerCase());
};

export const checkWillReloadOnForbidden = error =>
  !getIsNativePlatform() && !isLoanEditorRoute() && isReadRequestError(error);
